import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Download } from './download.model';

const axios = useAxios();

export interface DownloadService {
  Fetch: () => Promise<AxiosResponse<Download[]>>;
}

const Fetch = (): Promise<AxiosResponse<Download[]>> =>
  axios.Get<Download[]>('api/downloads');

export default { Fetch } as DownloadService;
